import { Tooltip } from 'ui/tooltip';
import { FlexSpacer } from 'ui/flexSpacer';
import { AddNew16 } from 'ui/icons/aurora/16px';
import { CounterBadge } from 'ui/badge';
import { SecondaryButton } from 'ui/button';
import {
  CREATE_NEW_COLLECTION_TEXT,
  MISSING_MANAGE_CATALOGS_PERMISSION,
} from 'modules/catalog/catalogConstants';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const FieldTypesLink = styled(Link)`
  white-space: nowrap;
`;

type CatalogTableButtonRowProps = {
  canManageCatalogs: boolean;
  fireSegmentTrackCall: (eventName: string, eventProperties: Record<string, any>) => void;
  isCatalogCollectionsFlagOn: boolean;
  openCreateCollectionModal: () => void;
  tableName: string;
  definedFields: Object;
  undefinedFields: string[];
};

export const CatalogTableButtonRow = ({
  canManageCatalogs,
  definedFields = {},
  undefinedFields = [],
  isCatalogCollectionsFlagOn,
  openCreateCollectionModal,
  tableName,
  fireSegmentTrackCall,
}: CatalogTableButtonRowProps) => {
  const hasUndefinedFields = undefinedFields.length > 0;
  const hasNoDefinedFields = Object.keys(definedFields).length === 0;

  const fieldTypesLink = `/catalogs/table/${tableName}/fieldTypes`;
  return isCatalogCollectionsFlagOn ? (
    <FlexSpacer gap="actionGap">
      <Tooltip isEnabled={!canManageCatalogs} tooltipContent={MISSING_MANAGE_CATALOGS_PERMISSION}>
        <SecondaryButton
          data-test="createCollectionButton"
          isDisabled={!canManageCatalogs}
          onClick={openCreateCollectionModal}
        >
          <AddNew16 />
          {CREATE_NEW_COLLECTION_TEXT}
        </SecondaryButton>
      </Tooltip>
      <FieldTypesLink to={fieldTypesLink}>
        <SecondaryButton
          data-test="defineFieldTypesButton"
          onClick={() =>
            fireSegmentTrackCall('Catalog Field Types Viewed', {
              catalog_name: tableName,
              creation_method: 'ui',
            })
          }
        >
          {hasUndefinedFields || hasNoDefinedFields ? 'Define field types' : 'View field types'}
          {hasUndefinedFields && <CounterBadge>{undefinedFields.length}</CounterBadge>}
        </SecondaryButton>
      </FieldTypesLink>
    </FlexSpacer>
  ) : null;
};
